import styled from 'styled-components';

export const LugasActiveDialogBoxLine = styled.div`
  margin:30px 5px 5px;
  border-bottom: 2px solid ${({theme}) => theme.colors.boxBorderLighter};
`;